<template>
  <div>
   <b-navbar toggleable="lg" class="" id="nav"  v-if="showNav == true && $router.currentRoute.name === 'Home'">
      <b-navbar-brand to="/" >
        <logo class="nav-logo"/>
      </b-navbar-brand>
      <b-navbar-toggle class="toggler1" target="nav-collapse">
        <burger :fill="'#fff'"/>
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="mr-139">
          <b-nav-item to="/">Главная</b-nav-item>
          <b-nav-item to="/services">Услуги</b-nav-item>
          <b-nav-item to="/about">Обо мне</b-nav-item>
          <b-nav-item to="/stories">Статьи</b-nav-item>
          <b-nav-item to="/video">Видео</b-nav-item>
          <b-nav-item to="/admin/adminHistoryPage" v-if="uId">Админ</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav>
          <a class="favorite-link"  href="https://www.youtube.com/channel/UCbMgwAs663J_8FcBdWimtKg" target="_blank"><Youtube :fill="'#fff'"/></a>
          <a class="favorite-link" href="https://www.instagram.com/psiholog_rambelli/" target="_blank"><Instagram :fill="'#fff'"/></a>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-navbar toggleable="lg" id="nav2"  class="Nav" v-else>
      <b-navbar-brand to="/" >
        <logo-footer class="nav-logo"/>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse">
        <burger :fill="'#cad4e5'"/>
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="mr-139">
          <b-nav-item to="/" >Главная</b-nav-item>
          <b-nav-item to="/services">Услуги</b-nav-item>
          <b-nav-item to="/about">Обо мне</b-nav-item>
          <b-nav-item to="/stories" :active="$route.name === 'Stories'">Статьи</b-nav-item>
          <b-nav-item to="/video" :active="$route.name === 'Video'">Видео</b-nav-item>
          <b-nav-item to="/admin/adminHistoryPage" v-if="uId">Админ</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav>
          <a class="favorite-link" href="https://www.youtube.com/channel/UCbMgwAs663J_8FcBdWimtKg" target="_blank"><Youtube :fill="'#7E7E7E'"/></a>
          <a class="favorite-link" href="https://www.instagram.com/psiholog_rambelli/" target="_blank"><Instagram :fill="'#7E7E7E'"/></a>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import Logo from '@/components/icons/Logo';
  import Instagram from '@/components/icons/Instagram';
  import Youtube from '@/components/icons/Youtube';
  import Cross from '@/components/icons/Cross2'
  import LogoFooter from '@/components/icons/LogoFooter';
  import Burger from '@/components/icons/Burger';
  export default {
    name: "NavBar",
    components: {Logo, Instagram, Youtube, LogoFooter, Cross, Burger},
    props: ['showNav'],
    computed: {
      ...mapState('auth', ['uId'])
    }
  }
</script>

<style lang="scss">
  button,
  button:active,
  button:focus {
    outline: none !important;
    border: none !important;
  }
  button.navbar-toggler.toggler1 {
    border: none !important;
    border-style: none !important;
    border-width: 0;
  }
  #nav.white-bg {
    background: #fff !important;
    color: #fff;
    position: fixed !important;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
    .nav-item {
      margin-right: 48px;
      .nav-link {
        color: #1f1f1f !important;
        font-weight: normal !important;
      }
    }
  }
  #nav a.router-link-exact-active, {
    color: #5ec8f5 !important;
  }
  #nav2 a.nav-link.router-link-exact-active {
    color: #5ec8f5 !important;
  }
  #nav a.active, {
    color: #5ec8f5 !important;
  }
  #nav2 a.nav-link.active {
    color: #5ec8f5 !important;
  }
  #nav2 {
    .show {
    }
    background: #fff;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
    position: fixed !important;
    .nav-item {
      margin-right: 48px;
      .nav-link {
        color: #1f1f1f !important;
        font-weight: normal !important;
      }
    }
  }
  #nav, #nav2 {
    .navbar-brand {
      padding: 0 !important;
    }
    position: absolute;
    z-index: 111;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 16px;
    padding-bottom: 16px;
    font-family: 'Raleway', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    .navbar-collapse {
      flex-grow: unset;
    }
    .nav-logo {
      margin-right: 53px;
    }
    .mr-139 {
      margin-right: 171px;
    }
    .nav-item {
      margin-right: 48px;
      .nav-link {
        color: #fff;
        font-weight: normal;
        padding: 0;
      }
    }
    .nav-item:last-child {
      margin-right: 0px;
    }
    .favorite {
      &-link {
        margin-right: 24px;
      }
      &-link:last-child {
        margin-right: 0;
      }
    }
  }

  @media screen and (max-width: 992px){
    #nav {
      background:  rgba(31, 31, 31, 0.95);
      .show {
      }
      .mr-139 {
        margin-right: 0 !important;
      }
      .nav-logo {
        margin-right: 0;
      }
      .nav-item {
        margin-right: 0;
        .nav-link {
          padding: 0.5rem 1rem !important;
        }
      }

      .navbar-nav:nth-child(2) {
        display: block;
      }
    }
    .navbar-light .navbar-toggler.toggler1 {
      position: absolute;
      right: 24px;
      top: 24px;
      border-color: unset !important;
      color: unset;
    }
    #nav {
      .nav-item:nth-child(1) {
        margin-top: 20px;
      }
      .navbar-nav:nth-child(2) {
        margin-top: 8px;
        flex-direction: unset;
        justify-content: center;
        display: flex;
        flex-wrap: nowrap !important;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 16px;
        .favorite-link {
          display: block;
          width: auto;
        }
      }
    }
    #nav2 {
      background: #fff;
      padding: 16px 0;
      transition: .5s;
      .mr-139 {
        margin-right: 0;
      }
      .nav-item:nth-child(1) {
        margin-top: 20px;
      }
      .nav-item {
        margin-right: 0;
        text-align: center;
        .nav-link {
          padding: 0.5rem 1rem !important;
        }
      }
      .navbar-nav:nth-child(2) {
        margin-top: 8px;
        flex-direction: unset;
        justify-content: center;
        display: flex;
        flex-wrap: nowrap !important;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 16px;
        .favorite-link {
          display: block;
          width: auto;
        }
      }
    }
    #nav2 .nav-logo {
      margin-right: 0;
    }
    .navbar-light .navbar-toggler {
      position: absolute;
      right: 24px;
      top: 24px;
      border-color: #fff !important;
    }
    .navbar-collapse.collapse.show {

    }
  }
</style>